import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LOGO_COLOR } from '@/lib/logos';
import { useI18n } from '@/lib/I18nContext';

export default function LegalPageLayout({ title, lastUpdated, children }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen font-body" style={{ background: '#FAFBFC', color: '#1E293B' }}>
      {/* Header */}
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-6" style={{ height: 64 }}>
          <Link to="/" className="flex items-center shrink-0">
            <img
              src={LOGO_COLOR}
              alt="Bezkraen"
              className="w-auto object-contain"
              style={{ height: 24 }}
            />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-800 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('legal.back_home')}
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16">
        <p className="text-xs font-medium uppercase tracking-wider text-gray-400 mb-2">Documento legal</p>
        <h1 className="font-heading font-bold text-gray-900 mb-2" style={{ fontSize: 'clamp(1.5rem, 5vw, 2.25rem)', lineHeight: 1.2 }}>
          {title}
        </h1>
        <p className="text-sm text-gray-400 mb-10" style={{ fontSize: 13 }}>
          {t('legal.last_updated')}: {lastUpdated}
        </p>

        <div className="prose prose-slate prose-sm max-w-none" style={{ color: '#334155', lineHeight: 1.85 }}>
          {children}
        </div>

        {/* Back button */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-600 hover:text-gray-800 hover:border-gray-300 hover:shadow-sm transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('legal.back_home')}
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-6">
        <div className="max-w-3xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src={LOGO_COLOR} alt="Bezkraen" className="h-5 w-auto object-contain" />
            <span className="text-xs text-gray-400">© 2026 Bezkraen</span>
          </div>
          <div className="flex items-center gap-4 text-xs text-gray-400">
            <Link to="/privacy-policy" className="hover:text-gray-600 transition-colors">{t('landing.footer_privacy')}</Link>
            <Link to="/terms-of-service" className="hover:text-gray-600 transition-colors">{t('landing.footer_terms')}</Link>
            <Link to="/data-deletion" className="hover:text-gray-600 transition-colors">{t('landing.footer_data_deletion')}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}